import { FC } from 'react';
import { ChassisType } from '../../../@types/ChassisType';
import ChassisOption from '../ChassisOption/ChassisOption';
import { Stack } from '@mui/material';
import { X2 as X2_2025 } from '../../../data/products/Carts/XSeriesProducts/X2/X2Chassis-2025';
import { X2Assy as X2Assy2025 } from '../../../data/products/Carts/XSeriesProducts/X2/X2Chassis-2025';
import { X4 as X4_2025 } from '../../../data/products/Carts/XSeriesProducts/X4/X4Chassis-2025';
import { X4Assy as X4Assy2025 } from '../../../data/products/Carts/XSeriesProducts/X4/X4Chassis-2025';
import { X6 as X6_2025 } from '../../../data/products/Carts/XSeriesProducts/X6/X6Chassis-2025';
import { X6Assy as X6Assy2025 } from '../../../data/products/Carts/XSeriesProducts/X6/X6Chassis-2025';

interface XSeriesChassisOptionsProps {
  preassembled: boolean,
  retailConfigurator: boolean,
  handleTabChange: (event: any, tab: string, chassisType?: ChassisType) => void,
  hideAllPrices: boolean,
}

const XSeriesChassisOptions: FC<XSeriesChassisOptionsProps> = ({ preassembled, retailConfigurator, handleTabChange, hideAllPrices }) => {
  const chassisOptionsLatestYear = retailConfigurator ? [X4Assy2025, X6Assy2025] : preassembled ? [X2Assy2025, X4Assy2025, X6Assy2025] : [X2_2025, X4_2025, X6_2025];
  return (
    <>
      {!retailConfigurator &&
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="center"
          useFlexGap
          flexWrap="wrap"
          spacing={6}>
          {chassisOptionsLatestYear.map((chassisType, index) => (
            <a
              style={{ cursor: 'pointer', zIndex: 1 }}
              key={index}
              onClick={() =>
                handleTabChange(undefined, '/cart-builder', chassisType)}>
              <ChassisOption
                chassisOption={chassisType}
                retailConfigurator={retailConfigurator}
                showPrice={!hideAllPrices} />
            </a>
          ))}
        </Stack>
      }
      {retailConfigurator &&
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="center"
          useFlexGap
          flexWrap="wrap"
          spacing={6}>
          {chassisOptionsLatestYear.map((chassisType, index) => (
            <a
              style={{ cursor: 'pointer', zIndex: 1 }}
              key={index}
              onClick={() =>
                handleTabChange(undefined, '/cart-builder', chassisType)}>
              <ChassisOption
                chassisOption={chassisType}
                retailConfigurator={retailConfigurator}
                showPrice={!hideAllPrices} />
            </a>
          ))}
        </Stack>
      }
    </>
  );
}

export default XSeriesChassisOptions;
